module.exports = __webpack_public_path__ + "img/loadingCircle.png";